import { useEffect } from "react";

const BASE = "ARTILLERY KDP — Kenny DePrince";

export const usePageTitle = (title) => {
  useEffect(() => {
    document.title = title ? `${title} | ${BASE}` : `${BASE} | Original Art, Signed Limited Editions, Custom Murals`;
    return () => { document.title = BASE; };
  }, [title]);
};
